import { useContext } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { getESimSwapRoute } from "@api-routes/eirCustomersFacade";
import { useFetch } from "@common/hook/useFetch";

interface IParams {
    onSuccessCallback(): void;
    openErrorModal(): void;
    closeErrorModal(): void;
}

export const useReplacementESim = (props: IParams) => {
    const { onSuccessCallback, openErrorModal, closeErrorModal } = props;
    const { selectedService } = useContext(SelectedServiceContext);
    const [postReplacementSimState, { post }] = useFetch();

    const postReplacementESim = () =>
        post<boolean>(getESimSwapRoute(), {
            body: { serviceId: selectedService?.id },
            forwardError: true,
        });

    const postReplacementESimInitial = () => {
        const postReplacementSimResult = postReplacementESim();

        if (postReplacementSimResult) {
            postReplacementSimResult
                .then(() => {
                    onSuccessCallback();
                })
                .catch(() => {
                    openErrorModal();
                });
        }
    };

    const postReplacementESimAfterError = () => {
        const postReplacementSimResult = postReplacementESim();

        if (postReplacementSimResult) {
            postReplacementSimResult.then(() => {
                closeErrorModal();
                onSuccessCallback();
            });
        }
    };

    return {
        postReplacementSimState,
        postReplacementESimInitial,
        postReplacementESimAfterError,
    };
};
